import { cancerscreenFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/cancerscreen.field-set';
import { carrierFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/carrier.field-set';
import { galleriFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/galleri.field-set';
import { monoFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/mono.field-set';
import { negSingleCarrierFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/neg-single-carrier.field-set';
import { niptFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/nipt.field-set';
import { nipptFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/nippt.field-set';
import { paternityFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/paternity.field-set';
import { rhFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/rh.field-set';
import { venisafeMaternaFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/venisafe-materna.field-set';
import { venisafeFieldSet } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/venisafe.field-set';
import { DataInputType } from '@core/core.types';

export const serviceDataFieldConfiguration: {
  [groupKey: string]: string[];
} = {
  [DataInputType.NIPT]: niptFieldSet,
  [DataInputType.NIPPT]: nipptFieldSet,
  [DataInputType.MONO]: monoFieldSet,
  [DataInputType.RH]: rhFieldSet,
  [DataInputType.CARRIER]: carrierFieldSet,
  [DataInputType.CANCERSCREEN]: cancerscreenFieldSet,
  [DataInputType.GALLERI]: galleriFieldSet,
  [DataInputType.PATERNITY]: paternityFieldSet,
  [DataInputType.NEGSINGLECARRIER]: negSingleCarrierFieldSet,
  [DataInputType.VENISAFEMATERNA]: venisafeMaternaFieldSet,
  [DataInputType.VENISAFE]: venisafeFieldSet,
  [DataInputType.OTHER]: [],
};
